import React from "react";
import { useTranslation } from "react-i18next";
import bigPrizeImage from "../../assets/big-prize.png";
import placeholderImage from "../../assets/another-prize.png";
import ShareCard from "../../common/ShareCard";
import PrizesInfoCard from "../../common/PrizesInfoCard";
import styles from "./PrizesFragment.module.css";

const PrizesFragment = ({ goToRules }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<div className={styles.prizesContainer}>
				<PrizesInfoCard onButtonClick={goToRules} />

				{/* Grand Prize */}
				<div className={styles.prizeCard}>
					<div>
						<img className={styles.prizeImage} style={{ height: "auto" }} src={bigPrizeImage} alt="Big prize" />
					</div>
					<div className={styles.prizeCardContent} style={{ paddingTop: 0 }}>
						<h2 className={styles.prizeTitle}>{t("prizes.prizeCard1.title")}</h2>
						<p className={styles.prizeDescription}>{t("prizes.prizeCard1.description")}</p>
					</div>
				</div>

				{/* Round Winner */}
				<div className={styles.prizeCard}>
					<div>
						<img className={styles.prizeImage} src={placeholderImage} alt="Big prize" />
					</div>
					<div className={styles.prizeCardContent}>
						<h2 className={styles.prizeTitle}>{t("prizes.prizeCard2.title")}</h2>
						<p className={styles.prizeDescription}>{t("prizes.prizeCard2.description")}</p>
					</div>
				</div>

				{/* Weekly Winner */}
				<div className={styles.prizeCard}>
					<div>
						<img className={styles.prizeImage} src={placeholderImage} alt="Big prize" />
					</div>
					<div className={styles.prizeCardContent}>
						<h2 className={styles.prizeTitle}>{t("prizes.prizeCard3.title")}</h2>
						<p className={styles.prizeDescription}>{t("prizes.prizeCard3.description")}</p>
					</div>
				</div>

				{/* Invite Friends */}
				<ShareCard />
			</div>
		</div>
	);
};

export default PrizesFragment;
